import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Building2,
  Users,
  Kanban,
  Activity,
  Download,
  Settings,
  Shield,
  BarChart3,
  LogOut,
  Factory,
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import PappersCredits from './PappersCredits';

const Layout: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { to: '/', icon: LayoutDashboard, label: 'Tableau de bord' },
    { to: '/companies', icon: Building2, label: 'Entreprises' },
    { to: '/contacts', icon: Users, label: 'Contacts' },
    { to: '/pipeline', icon: Kanban, label: 'Pipeline' },
    { to: '/activities', icon: Activity, label: 'Activités' },
    { to: '/pappers', icon: Download, label: 'Import Pappers' },
    { to: '/compliance', icon: Shield, label: 'Conformité' },
  ];

  const adminItems = [
    { to: '/admin/users', icon: Settings, label: 'Utilisateurs' },
    { to: '/admin/scoring', icon: BarChart3, label: 'Scoring' },
    { to: '/admin/naf-codes', icon: Factory, label: 'Codes NAF' },
  ];

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <Factory size={24} />
          Industrial CRM
        </div>
        <nav className="sidebar-nav">
          <div className="sidebar-section-title">Menu principal</div>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            >
              <item.icon size={20} />
              {item.label}
            </NavLink>
          ))}

          {user?.role === 'admin' && (
            <>
              <div className="sidebar-section-title">Administration</div>
              {adminItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                >
                  <item.icon size={20} />
                  {item.label}
                </NavLink>
              ))}
            </>
          )}
        </nav>
      </aside>

      <div className="main-wrapper">
        <header className="topbar">
          <div className="topbar-left">
            <span className="topbar-title"></span>
          </div>
          <div className="topbar-right">
            <PappersCredits />
            <div className="topbar-user">
              <span className="topbar-user-name">
                {user?.firstName} {user?.lastName}
              </span>
              <span className="topbar-user-role">{user?.role}</span>
            </div>
            <button className="btn btn-sm" onClick={handleLogout}>
              <LogOut size={16} />
              Déconnexion
            </button>
          </div>
        </header>

        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
